// extracted by mini-css-extract-plugin
module.exports = {"leftContent":"_category__leftContent__53XYE","rightContent":"_category__rightContent__981lM"};